import { AppProvider } from '@!/providers'
import BookPurchaseError from '../containers/BookPurchaseError'
import { useAppSettings } from '@!/Hooks/useAppSettings'

const BookPurchaseErrorApp = (props) => {
  const jotaiStore = useAppSettings({ isSaveLastUrl: false })

  return (
    <AppProvider jotaiStore={jotaiStore}>
      <BookPurchaseError errorMessage={props.errorMessage} {...props} />
    </AppProvider>
  )
}

export default BookPurchaseErrorApp
